<template>
  <NHBox>
    <div class="px-4 text-2xl">
      <NHLabelText :input-style="{ textAlign: 'right' }" :label-style="{ width: 30 + '%' }" name="수표">
        {{ checkCnt }}

        <template slot="suffix">
          <div>만원</div>
        </template>
      </NHLabelText>
      <NHLabelText
        class="mt-4"
        :input-style="{ textAlign: 'right' }"
        :label-style="{ width: 30 + '%' }"
        name="5 만원권"
      >
        {{ x5Cnt }}

        <template slot="suffix">
          <div>만원</div>
        </template>
      </NHLabelText>
      <NHLabelText
        class="mt-4"
        :input-style="{ textAlign: 'right' }"
        :label-style="{ width: 30 + '%' }"
        name="1 만원권"
      >
        {{ x1Cnt }}

        <template slot="suffix">
          <div>만원</div>
        </template>
      </NHLabelText>
      <NHLabelText class="mt-4" :input-style="{ textAlign: 'right' }" :label-style="{ width: 30 + '%' }" name="합계">
        {{ totalPrice }}

        <template slot="suffix">
          <div>만원</div>
        </template>
      </NHLabelText>
    </div>
  </NHBox>
</template>

<script>
import NHLabelText from '@src/games/nonghyup/components/nh-label-text.vue'
import NHBox from '@src/games/nonghyup/components/nh-box.vue'

export default {
  name: 'NHConfirmList',
  components: { NHBox, NHLabelText },
  props: {
    checkCnt: {
      type: Number,
      required: true,
    },
    x5Cnt: {
      type: Number,
      required: true,
    },
    x1Cnt: {
      type: Number,
      required: true,
    },
    totalPrice: {
      type: Number,
      required: true,
    },
  },
}
</script>
